/** Only use this service when you have to manipulate stuff outside the scope of React code. */
const DOMService = {
    replaceClass: (currentClassName, newClassName) => {
        const [sanitizedCurrentClasName, sanitizedNewClassName] = [currentClassName, newClassName].map((value) => {
            return value.charAt(0) === '.' ? value.substring(1) : value;
        });
        document.querySelectorAll('.' + sanitizedCurrentClasName).forEach((element) => {
            element.classList.remove(sanitizedCurrentClasName);
            element.classList.add(sanitizedNewClassName);
        });
    },
    setDisplayById: (id, value) => {
        id = id.charAt(0) === '#' ? id : '#' + id;
        const element = document.querySelector(id);
        if (element) {
            element.style.display = value;
        }
    },
    setOrRemoveStylePropertyBySelector: (query, styleProperty, value = null) => {
        const element = document.querySelector(query);
        if (element) {
            value === null
                ? element.style.removeProperty(styleProperty)
                : element.style.setProperty(styleProperty, value);
        }
    },
    setAttributeOnElementBySelector: (attributeName, attributeValue, querySelector) => {
        const element = document.querySelector(querySelector);
        if (element) {
            element.setAttribute(attributeName, attributeValue);
        }
    },
};
export default DOMService;
